import { render } from "./App.vue?vue&type=template&id=0cea70ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0cea70ca&lang=css"

import exportComponent from "C:\\Users\\Owner\\source\\training-generator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__